import { logoutIcon } from "@excalidraw/excalidraw/components/icons";

import { useAtom, useAtomValue } from "../app-jotai";
import { authStateAtom, userAtom } from "../auth/authAtoms";
import { logout as logoutApi } from "../auth/authApi";
import { clearAuthData } from "../auth/authStorage";

import "./SignOutButton.scss";

export const SignOutButton = () => {
  const [, setAuthState] = useAtom(authStateAtom);
  const user = useAtomValue(userAtom);

  const handleLogout = async () => {
    try {
      await logoutApi();
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      // Clear local auth data
      clearAuthData();

      // Update auth state
      setAuthState({
        user: null,
        token: null,
        isAuthenticated: false,
        isLoading: false,
        error: null,
      });

      // Reload the page to reset the app
      window.location.reload();
    }
  };

  if (!user) {
    return null;
  }

  return (
    <button
      className="SignOutButton"
      onClick={handleLogout}
      title={`Sign out (${user.username})`}
      aria-label={`Sign out ${user.username}`}
    >
      {logoutIcon}
    </button>
  );
};
